import styled from 'styled-components';

export const Overlay = styled.div<{ $active?: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100; // on top of click to unmute
  pointer-events: ${(p) => p.$active ? 'auto' : 'none'};
`;
